import { refreshTokens } from '../services/authenticationServices';

/**
 * Utility function to make API requests with automatic token refresh on 401 errors
 * @param {string} url - The API endpoint URL
 * @param {Object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise} - Promise that resolves to the response
 */
export const makeAuthenticatedRequest = async (url, options = {}) => {
  let token = localStorage.getItem('access_token');
  if (!token) throw new Error('Not authenticated');

  const makeRequest = async (authToken) => {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
        ...options.headers
      }
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  };

  try {
    return await makeRequest(token);
  } catch (error) {
    if (error.message === 'UNAUTHORIZED') {
      try {
        const refreshRes = await refreshTokens();
        token = refreshRes?.data?.access_token;
        if (token) {
          localStorage.setItem('access_token', token);
          return await makeRequest(token);
        }
      } catch (refreshErr) {
        console.error('Token refresh failed on 401:', refreshErr);
        if (window.authContext?.logout) {
          await window.authContext.logout();
        }
        throw refreshErr;
      }
    }
    throw error;
  }
}; 